import React from 'react';
import { Button } from './ui/Button';
import { Reveal } from './ui/Reveal';
import { ChevronDown, ShieldCheck, FileText, BookOpen } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-navy-900 pt-20" data-id="element-222">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0" data-id="element-223">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-navy-800 via-navy-900 to-navy-900 opacity-80" data-id="element-224"></div>
        <div className="absolute top-0 left-0 w-full h-full bg-[url('https://images.unsplash.com/photo-1579548122080-c35fd6820ecb?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-10 mix-blend-overlay" data-id="element-225"></div>
        <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-226"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-227">
        <Reveal data-id="element-228">
          {/* Headshot */}
          <div className="mb-6 flex justify-center" data-id="element-229">
            <div className="relative w-28 h-28 md:w-36 md:h-36" data-id="element-230">
              <div className="absolute inset-0 rounded-full border-2 border-gold-500 shadow-[0_0_24px_rgba(197,165,90,0.3)]" data-id="element-231"></div>
              <img src="https://cdn.magicpatterns.com/uploads/qHTWKxA3Q89G5ZvNigM12i/1698369576334.jpg" alt="Guy C. Beougher" className="w-full h-full rounded-full object-cover object-top" data-id="element-232" />
            </div>
          </div>
        </Reveal>

        <Reveal data-id="element-233">
          <div className="inline-flex items-center gap-2 mb-6 px-4 py-1 border border-gold-500/30 bg-gold-500/10 backdrop-blur-sm rounded-sm" data-id="element-234">
            <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-235" />
            <span className="text-gold-500 font-heading text-sm tracking-[0.2em] uppercase" data-id="element-236">
              Active Top Secret / SCI Clearance
            </span>
          </div>
        </Reveal>

        <Reveal delay={200} data-id="element-237">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white uppercase tracking-tight mb-4 leading-none" data-id="element-238">
            Guy C.{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-gold-600" data-id="element-239">
              Beougher
            </span>
          </h1>
        </Reveal>

        <Reveal delay={400} data-id="element-240">
          <h2 className="text-xl md:text-2xl text-white font-heading uppercase tracking-widest mb-6" data-id="element-241">
            Former SES Tier I & II Executive{' '}
            <span className="text-gold-500 mx-2" data-id="element-242">|</span> Vice President, DoD &
            Federal Logistics
          </h2>
        </Reveal>

        <Reveal delay={500} data-id="element-243">
          <p className="text-lg md:text-xl text-slate-300 font-light max-w-3xl mx-auto mb-10 leading-relaxed italic" data-id="element-244">
            "Commanding Enterprise-Scale Defense Logistics Across the Global
            Battlespace"
          </p>
        </Reveal>

        <Reveal delay={600} data-id="element-245">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6" data-id="element-246">
            <Button size="lg" onClick={() => document.getElementById('contact')?.scrollIntoView()} data-id="element-247">
              Open to Opportunities
            </Button>
            <Button variant="outline" size="lg" onClick={() => document.getElementById('ses-leadership')?.scrollIntoView()} data-id="element-248">
              View Experience
            </Button>
            <Button variant="ghost" size="lg" onClick={() => document.getElementById('contact')?.scrollIntoView()} data-id="element-249">
              Connect
            </Button>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-6" data-id="element-250">
            <a href="https://heyzine.com/flip-book/047bd9d693.html" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-2 border border-gold-500/40 bg-gold-500/10 text-gold-500 font-heading text-xs uppercase tracking-widest hover:bg-gold-500/20 transition-colors rounded-sm" data-id="element-251">
              <FileText className="w-4 h-4" data-id="element-252" />
              View Resume
            </a>
            <a href="https://heyzine.com/flip-book/287c03f7ce.html" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-2 border border-gold-500/40 bg-gold-500/10 text-gold-500 font-heading text-xs uppercase tracking-widest hover:bg-gold-500/20 transition-colors rounded-sm" data-id="element-253">
              <BookOpen className="w-4 h-4" data-id="element-254" />
              Leadership Philosophy
            </a>
          </div>
        </Reveal>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce text-gold-500/50" data-id="element-255">
        <ChevronDown size={32} data-id="element-256" />
      </div>
    </section>;
}